import createSimplePrivateGallery from '@PROJECT_ROOT/assets/desktop/js/search/simplePrivateGallery';
import floatingHeader from '@PROJECT_ROOT/assets/mobile/js/guide/floatingHeader';
import initFloatingBar from '@PROJECT_ROOT/assets/shared/js/library/floatingBar';

$(() => {
    initFloatingBar('#guideSearchButton', 'bottom');
    floatingHeader('.floatingHeaderGuide');

    const $beachSearchForm = $('#beachSearchForm');
    const $pageLoader = $('#pageLoader');

    $('.beachResultSimpleGallery').toArray().forEach((galleryElement) => {
        const $galleryContainer = $(galleryElement);

        createSimplePrivateGallery({
            source: $galleryContainer.data('source').map((image) => ({ url: image.standard })),
            nextButton: $galleryContainer.find('.simpleGalleryNext')[0],
            previousButton: $galleryContainer.find('.simpleGalleryPrev')[0],
            counterElement: $galleryContainer.find('.simpleGalleryCounter')[0],
            imageElement: $galleryContainer.find('.currentImage img')[0],
        });
    });

    $beachSearchForm.on('submit', (e) => {
        e.preventDefault();
        $pageLoader.show();
        $.get($beachSearchForm.data('beachesajaxurl'), $beachSearchForm.serialize())
            .then(
                (response) => {
                    $('#beachList').html(response.beachesHtml);

                    if (window.history.replaceState) {
                        window.history.replaceState({}, '', response.contentUrl);
                    }

                    $pageLoader.hide();
                },
                () => $pageLoader.hide(),
            );
    });
});
